import { store } from "../../store/index"

export const getFiltersByNamespace = (namespace) =>
  store.getState().auth.user?.settings?.filters?.[namespace] || {}
